module.exports = __webpack_public_path__ + "img/2.1c5f7010.png";